var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content-end"},[_c('StaffGroupSchedulePurgeButton',{on:{"button-clicked":_vm.deleteSchedule}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }